import { render, staticRenderFns } from "./rel-serv-pack.vue?vue&type=template&id=12d95d83&scoped=true"
import script from "./rel-serv-pack.vue?vue&type=script&lang=js"
export * from "./rel-serv-pack.vue?vue&type=script&lang=js"
import style0 from "./rel-serv-pack.vue?vue&type=style&index=0&id=12d95d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d95d83",
  null
  
)

export default component.exports